export default __webpack_public_path__ + "static/media/register-illustration.9e74597f.webp";